"use client";

import Script from "next/script";
import { useEffect } from "react";
import { useMicrosoftLogin } from "@/hooks/use-microsoft-login";
import { portalUrl } from "@/lib/portal";

// Portal fora do ar (nav.js não carregou): o app segue sem a barra (o CSS global,
// data-portal-nav="failed", tira o espaço dela) e o portalSession() resolve null,
// para o login seguir direto pela Microsoft.
function hideNav() {
  document.documentElement.dataset.portalNav = "failed";
  document.dispatchEvent(new Event("sptech-portal:unavailable"));
}

// Barra compartilhada do portal (<sptech-app-nav>), servida pelo
// sptech.ia.portal.ui em /portal/nav.js. O usuário exibido vem do portal, e é a
// barra que leva ao login do portal e limpa a sessão do app quando o portal sai.
// Este app só diz qual é o app atual e, no "Sair", apaga o próprio cookie httpOnly
// (a barra não alcança).
export function PortalNav() {
  const { logout } = useMicrosoftLogin();

  // Antes de sair do app ("Sair", "Trocar de conta" ou portal deslogado), a barra
  // avisa: este app limpa o cookie e o cache MSAL e segue para o destino.
  useEffect(() => {
    const onLogout = (event: Event) => {
      event.preventDefault();
      void logout((event as CustomEvent<{ href: string }>).detail.href);
    };
    document.addEventListener("sptech-app-nav:logout", onLogout);
    return () => document.removeEventListener("sptech-app-nav:logout", onLogout);
  }, [logout]);

  return (
    <>
      {/* Skeleton da barra enquanto o nav.js carrega (também servido pelo portal). */}
      <link rel="stylesheet" href={portalUrl("/portal/nav.css")} />
      <Script src={portalUrl("/portal/nav.js")} strategy="afterInteractive" onError={hideNav} />
      <sptech-app-nav current="agente_acad" />
    </>
  );
}
